export default "__VITE_ASSET__Yde1uY_J__"